import { render, staticRenderFns } from "./SalesProcessForm.vue?vue&type=template&id=6b99ec66&scoped=true"
import script from "./SalesProcessForm.vue?vue&type=script&lang=ts"
export * from "./SalesProcessForm.vue?vue&type=script&lang=ts"
import style0 from "./SalesProcessForm.vue?vue&type=style&index=0&id=6b99ec66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b99ec66",
  null
  
)

export default component.exports